export const removeEmptyFields = (obj) => {
    if (!obj) {
        return {};
    }

    Object.keys(obj).forEach((key) => (obj[key] === undefined || obj[key] === null) && delete obj[key]);
    return obj;
};
